module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Ormont-Dessous_(Vaud)-5015a36f125d3458bf8881140805d8bf.svg";